import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MainService } from '../../services/main.service';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service';

@Component({
    selector: 'app-dialog-add-seller',
    templateUrl: './dialog-add-seller.component.html',
    styleUrls: ['./dialog-add-seller.component.scss'],
    // providers: [
    //   { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    //   { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    // ],
})
export class DialogAddSellerComponent implements OnInit {
    lengthReferencia: number = 0;
    stores: any
    storesFiltered: any
    types: any
    state: any = ["A", "I"]
    title: string = "Agregar Cajero"
    description: string = "Ingrese los datos del nuevo cajero"
    showFieldAudit = false;
    showFieldInactive = false;
    types_cash: any = ["S", "A", "P"]

    form: FormGroup;


    constructor(private commonService: CommonService, private mdDialogRef: MatDialogRef<DialogAddSellerComponent>, private mainService: MainService, private fb: FormBuilder, private helpers: HelpersService) {

        this.form = this.fb.group({
            codigo: [''],
            doc: [''],
            des: [''],
            usuario: [''],
            tienda: [''],
            est: ['A'],
            tipo: ['C'],
            cajarap: [''],
            t_cajero: ['']

        });


    }

    async ngOnInit(): Promise<void> {
        this.stores = (await this.commonService.findAllStores())['data']
        this.storesFiltered = this.stores
    }
    async close() {
        this.mdDialogRef.close("close");
    }

    storeFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value.toUpperCase();
        console.log(filterValue)
        if (!filterValue) {
            this.storesFiltered = this.stores
            return
        }
        this.storesFiltered = this.stores.filter(store => store.C_AGE.includes(filterValue) || store.NOM.toUpperCase().includes(filterValue))

    }

    displayFn(code: any): string {
        return code ? `${code.C_AGE} - ${code.NOM}` : '';
    }
    async save() {
        let formu = this.form.value

        showSpinner()
        this.mainService.create(formu.codigo, formu.doc, formu.des, formu.usuario, formu.tienda.C_AGE, formu.est, formu.tipo, formu.cajarap, formu.t_cajero).then(e => {
            console.log(e.data)
            if (e.data["success"] && e.data["message"] == null) {
                this.mdDialogRef.close("save")

            }
            else {
                this.helpers.notifications.errorMessage('No se pudo guardar Cajero')
            }
            hideSpinner()
        })

    }


}